import { XUX_DATEPICKER_PERIODS } from '@geniuspos/ui-shared/modules/xdm-shared-components/definitions/constants/datepicker-specific-constants';

export const DATE_FILTER_TYPES = {
  CUSTOM: XUX_DATEPICKER_PERIODS.CUSTOM.id,
  FROM: 'from',
  TILL: 'till',
  SINGLE: XUX_DATEPICKER_PERIODS.SINGLE.id,
};

export const AvailableOptions = [
  {
    name: 'Till',
    id: DATE_FILTER_TYPES.TILL,
    type: 'single',
  },
  {
    name: 'From',
    id: DATE_FILTER_TYPES.FROM,
    type: 'single',
  },
  XUX_DATEPICKER_PERIODS.CUSTOM,
];

export enum DATE_PICKER_TYPES {
  SINGLE = 'single',
  RANGE = 'range',
  PERIODS = 'periods',
  PERIODS_WEEK = 'periodsWeek',
}
